import instance from "../../../services/api";

export const fetchCards = params => {
  return instance(true)
    .post(`/partner/problems/remont_cards/`, params)
    .then((res = {}) => {
      return res?.data;
    });
};
